import { useTypedQuery } from "hooks";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Question, QuestionID } from "models";

const sortQuestionElements = (question: Question) => ({
  ...question,
  question_elements: question.question_elements?.toSorted((a, b) => a.ordering - b.ordering)
});

export const useQuestionDetailsQuery = (id?: QuestionID) =>
  useTypedQuery({
    queryKey: QuestionsDashboardQueryKeys.questionDetails(id),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data.question,
    select: sortQuestionElements,
    enabled: !!id
  });
